export default "__VITE_ASSET__3ec860f0__"